import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=351b4680&"
import script from "./CalendarList.vue?vue&type=script&lang=js&"
export * from "./CalendarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActivitiesCalendar: require('/data/www/nvpa.org/nvpa/nuxt/components/activities/Calendar.vue').default})
